import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import FirstNameField from "./components/first_name";
import LastNameField from "./components/last_name";
import GenderField from "./components/gender";
import TextField from "./components/text";
import DOBField from "./components/dob";
import SelectField from "./components/select";
import BVNField from "./components/bvn";
import SelfieField from "./components/selfie";
import ImageField from "./components/image";
import FileField from "./components/file";
import DocumentField from "./components/document";
import ParagraphField from "./components/paragraph";
import SignaturePadField from "./components/signature_pad";
import NINField from "./components/nin";
import NumberField from "./components/number";
import GoogleAddressField from "./components/google_address";
import EmailAddressField from "./components/email_address";
import PhoneNumberField from "./components/phone_number";
import PasswordField from "./components/password";
import CurrentGPSLocation from "./components/gps_location";
import GeoLocationMapPoint from "./components/geo_point";
import DateField from "./components/date";
import MultiSelectField from "./components/multi_select";
import AudioRecorder from "./components/audio";
import VideoRecorder from "./components/video";
import RelatedDropDownsField from "./components/related_dropdowns";
import AmountField from "./components/amount";
import CalculatedValueField from "./components/calculated_value";
import DecimalField from "./components/decimal";
import GPSPerimeter from "./components/gps_perimeter";
import HumanFaceField from "./components/human_face";
import RelatedDropDown from "./components/related_dropdown";
import QRScannerField from "./components/qr_code";
import BarcodeReaderField from "./components/barcode_reader";
import FormulaValueField from "./components/formula_field";
import GeoTaggedImageField from "./components/geotag_image";
import GeoTaggedImageUploadField from "./components/geotagged_image_upload";
import CheckboxField from "./components/checkbox";
import MultiCheckboxField from "./components/multi_checkbox";
import RadioButtonGroupField from "./components/radio_button_group";
import PaymentField from "./components/payment_field";
import TimeField from "./components/time";

function FormSectionBuilder({ formRef, draftIndex, section, logic }) {
  const [sectionFields, setSectionFields] = useState([]);

  function buildSectionField(field) {
    let component = null;
    if (field.child !== null && field.data_field.related_field) {
      const rOpts = field.options;
      return (
        <RelatedDropDownsField
          displayNameParent={field.display_name}
          displayNameChild={field.child.display_name}
          fieldRefParent={field.reference}
          fieldRefChild={field.child.reference}
          relatedOptions={rOpts}
        />
      );
    }

    if (field.parent !== null && field.type === "related_dropdown") {
      return (
        <RelatedDropDown
          formRef={formRef}
          draftIndex={draftIndex}
          displayName={field.display_name}
          name={field.code}
          fieldRef={field.reference}
          parentRef={field.parent.reference}
          options={field.options}
        />
      );
    }

    switch (field.type) {
      case "first_name":
        component = (
          <FirstNameField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "last_name":
        component = (
          <LastNameField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gender":
        component = (
          <GenderField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "dob":
        component = (
          <DOBField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "date":
        component = (
          <DateField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "bvn":
        component = (
          <BVNField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "nin":
        component = (
          <NINField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "selfie":
        component = (
          <SelfieField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "image":
        component = (
          <ImageField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "file":
        component = (
          <FileField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "document":
        component = (
          <DocumentField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "signature":
        component = (
          <SignaturePadField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "text":
        component = (
          <TextField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "number":
        component = (
          <NumberField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "paragraph":
        component = (
          <ParagraphField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "google_address":
        component = (
          <GoogleAddressField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "email_address":
        component = (
          <EmailAddressField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "phone_number":
        component = (
          <PhoneNumberField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "select":
        component = (
          <SelectField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
            editable={field.editable}
          />
        );
        break;
      case "password":
        component = (
          <PasswordField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gps_location":
        component = (
          <CurrentGPSLocation
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geo_point":
        component = (
          <GeoLocationMapPoint
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "multi_select":
        component = (
          <MultiSelectField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "audio":
        component = (
          <AudioRecorder
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "video":
        component = (
          <VideoRecorder
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "amount":
        component = (
          <AmountField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "calculated_value":
        component = (
          <CalculatedValueField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "decimal":
        component = (
          <DecimalField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gps_perimeter":
        component = (
          <GPSPerimeter
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "human_face":
        component = (
          <HumanFaceField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "formula_field":
        component = (
          <FormulaValueField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "qr_code_scanner":
        component = (
          <QRScannerField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "barcode_reader":
        component = (
          <BarcodeReaderField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geotag_image":
        component = (
          <GeoTaggedImageField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geotagged_image_upload":
        component = (
          <GeoTaggedImageUploadField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "checkbox":
        component = (
          <CheckboxField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "multi_checkbox":
        component = (
          <MultiCheckboxField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "radio_button_group":
        component = (
          <RadioButtonGroupField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "payment_field":
        component = (
          <PaymentField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "time":
        component = (
          <TimeField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      default:
        component = (
          <TextField
            formRef={formRef}
            draftIndex={draftIndex}
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
    }

    return component;
  }

  useEffect(() => {
    const fields = [];
    section.fields.map((param) => {
      fields.push(param);
      return false;
    });
    // console.log(fields);
    setSectionFields(fields);
  }, [section]);

  return (
    <MDBox p={3}>
      <MDTypography variant="h6" fontWeight="medium">
        {section.title}
      </MDTypography>
      {section.description !== null && (
        <MDTypography variant="h6" fontWeight="light" fontSize={14}>
          {section.description}
        </MDTypography>
      )}

      {/* {sectionFields.map((field) => (
        <MDBox mt={2} mb={3}>
          {field}
        </MDBox>
      ))} */}
      {sectionFields.length > 0 && (
        <>
          {sectionFields.map((param) => {
            let field = buildSectionField(param);
            if (param.reference in logic.listeners) {
              const listener = logic.listeners[param.reference];
              let wID = `t_watcher_${listener.type}_${param.reference}`;
              const parentField = document.getElementById(
                `dff_${listener.trigger}`,
              );
              if (parentField !== null) {
                field = (
                  <div id={`${wID}`} style={{ display: "none" }}>
                    {field}
                  </div>
                );
                parentField.addEventListener("change", function () {
                  const d = document.getElementById(wID);
                  if (parentField.value !== listener.control) {
                    d.style.display = "none";
                    document.getElementById(`dff_${param.reference}`).value =
                      null;
                    document.getElementById(`dff_${param.reference}`).setAttribute("data-visible", "false");
                  } else {
                    d.style.display = "block";
                    document.getElementById(`dff_${param.reference}`).setAttribute("data-visible", "true");
                  }
                });
              }
            }
            return (
              <MDBox mt={2} mb={3}>
                {field}
              </MDBox>
            );
          })}
        </>
      )}
    </MDBox>
  );
}
// Typechecking props of the Transaction
FormSectionBuilder.propTypes = {
  formRef: PropTypes.isRequired,
  section: PropTypes.isRequired,
  logic: PropTypes.any,
};
export default FormSectionBuilder;
